import axios from 'axios';
import { toolUtils } from '../../../../utils/toolUtils.js'
import { Tag, Typography, Popconfirm, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import {
    CloseOutlined,
    CheckCircleOutlined,
    DragOutlined
} from '@ant-design/icons';

export default {
    getConference: async function (props, setFuncMap) {
        try {
            const res = await this.getConferenceByUidAction(props.conferenceUid)
            props.setContentHeader(res.data.name)
            setFuncMap.setIsPageLoading(false)
        } catch (error) {
        }
    },
    getConferenceByUidAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}`,
            headers: {
                "role": "topUser"
            }
        })
    },
    getIntroductions: async function (props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.getIntroductionsAction(props.conferenceUid)
            let result = {}
            res.data.forEach(item => {
                result[item.lang] = item
            })
            setFuncMap.setIntroductionMap(result)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    getIntroductionsAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}/introduction`,
            headers: {
                "role": "topUser"
            }
        })
    },
    updateIntroduction: async function (payload, props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.updateIntroductionAction(payload, props.conferenceUid)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    updateIntroductionAction: (payload, conferenceUid) => {
        return axios({
            method: 'POST',
            url: `/conference/${conferenceUid}/introduction`,
            headers: {
                "role": "topUser"
            },
            data: payload
        })
    },
    getIntroduction: async function (props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.getIntroductionsAction(props.conferenceUid)
            let result = {}
            res.data.forEach(item => {
                result[item.lang] = item
            })
            setFuncMap.setIntroductionMap(result)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    getIntroductionByIdAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}/introduction`,
            headers: {
                "role": "topUser"
            }
        })
    },
};
